import { useTranslation } from 'react-i18next'
import { Container } from './Container'
import { cn } from '../../lib/utils'

interface FooterProps {
  variant?: 'full' | 'simple'
}

export function Footer({ variant = 'full' }: FooterProps) {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  const links = [
    { label: t('footer.privacy'), href: '#' },
    { label: t('footer.terms'), href: '#' },
    { label: t('footer.contact'), href: '/#diagnostico' },
  ]

  return (
    <footer className={cn('border-t border-border bg-surface', variant === 'simple' && 'py-8')}>
      <Container size="wide" className={cn('py-12', variant === 'simple' && 'py-8')}>
        <div
          className={cn(
            'flex flex-col items-center justify-between gap-6',
            variant === 'full' ? 'md:flex-row' : 'sm:flex-row',
          )}
        >
          <div className="flex items-center gap-2">
            <span className="text-xl font-semibold text-gradient">EmpleaHoy IA</span>
          </div>

          {variant === 'full' && (
            <nav className="flex flex-wrap items-center justify-center gap-6">
              {links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-text-secondary transition-colors hover:text-text-primary"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          )}

          <p className="text-sm text-text-muted">
            © {currentYear} EmpleaHoy IA. {t('footer.rights')}
          </p>
        </div>
      </Container>
    </footer>
  )
}
